export default [
  'D8',
  'D9',
  'D10',
  'D11',
  'E7',
  'E8',
  'E9',
  'F7',
  'F8',
  'F9',
  'G6',
  'G7',
  'H6',
  'H7',
  'H8',
  'H9',
  'H10',
  'J6',
  'J7',
  'J8',
  'J9',
  'K6',
  'K7',
  'M6',
  'M7',
  'N6',
  'N7',
  'N8',
  'P7',
  'P9',
  'R7',
  'S7',
];
